import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';

@Component({
  selector: 'app-addCard-modal',
  templateUrl: './addCard-modal.component.html',
  styleUrls: ['./addCard-modal.component.scss']
})
export class AddCardModalComponent implements OnInit {
  addCardForm: any = this.fb.group({
    binFirst4: [''],
    binLast4: ['']
  });
  hideEvent: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private _authService: AuthService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public _bsModalRef: BsModalRef,
    private dataTransferService: DataTransferService
  ) { }

  ngOnInit(): void {

  }

  hideModal() {
    this.hideEvent.emit(true);
  }
  binError: boolean;
  binInvalid: boolean;
  isload2: boolean;
  @Output() addCardStatus = new EventEmitter();
  onKeyph(e) {
    this.binError = false;
    this.binInvalid = false;
    e.target.value = e.target.value.replace(/[^\d]/g, '').trim();
  }
  keytab(event, el) {
    this.binError = false;
    this.binInvalid = false;
    this.isload2 = false;
    if (event.currentTarget.value.length == 4) {
      // document.getElementById('last_four_card_digits').focus();
      el.focus();
    }
  }
  backkeytab(event, firstFocusable) {
    this.binError = false;
    this.binInvalid = false;
    this.isload2 = false;

    if (event.currentTarget.value.length == 0 && event.key == 'Backspace') {
      let elem = document.getElementById('first_four_card_digits')
      // elem.value = elem.value.slice(0, 3);
      elem.focus();
    }

  }
  btnActive: boolean = false;
  checkbtn() {
    this.btnActive = (this.addCardForm.value.binFirst4.length + this.addCardForm.value.binLast4.length) == 8 ? true : false;
  }
  addCardFormSubmit() {
    this.isload2 = true;
    let bin = this.addCardForm.value.binFirst4.toString() + this.addCardForm.value.binLast4.toString();
    this._authService.addCard(bin, 'first8').subscribe((response) => {
      if(response && response.data && response.data.attributes){
        localStorage.removeItem('userCards');
        this.checkIfBinValid(bin,response.data);
      }
    },
     (err) => {
      this.isload2 = false;
      this.binError = true;
    })

  }
  checkIfBinValid(bin,card) {
    this._authService.validateCard(bin, 'first8').subscribe(res => {
      if (res && res.data && res.data.attributes.bin == bin && res.data.attributes.status == 'bin_verified') {
        let current_user = JSON.parse(localStorage.getItem("currentUser"));
        current_user.token = res.data.attributes.session_token;
        localStorage.setItem('currentUser', JSON.stringify(current_user));
        localStorage.setItem('userCard', JSON.stringify(card));
        localStorage.setItem('uc', JSON.stringify(card.id));
        this.setCounrty(res.data.attributes?.country_id);
        this.isload2 = false;
        this.dataTransferService.nextRefreshEvent({refresh: true})
        setTimeout(() => {
          this.addCardStatus.emit(true);
        }, 300);
        this.toastr.success('Card added successfully!');
        this._bsModalRef.hide();
      }
      else {
        this.isload2 = false;
        this.binError = true;
        this.toastr.error('Something went wrong. Please try again!');
      }
    }, (err) => {
      this.isload2 = false;
      this.binError = true;
      console.log(err)
    })
  }
  setCounrty(countryId){
    let userCountry = JSON.parse(localStorage.getItem("userCountry"));
    if(countryId && countryId !== userCountry.id){
      let allCountries = JSON.parse(localStorage.getItem("allCountries"));
      let userCountryNew = allCountries.filter((obj) => obj.attributes.id == countryId);
      if(userCountryNew){
        localStorage.setItem("userCountry", JSON.stringify(userCountryNew[0]));
      }
    }
  }

  closeModalRef(){
    this._bsModalRef.hide();
  }
}
